import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { fetchContentCollection } from "../../behavior/api/content";
import { TabSelector } from "../../components/elements";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import BannerSection from "../../components/learnWithHubert/BannerSection";
import CareerGuides from "../../components/learnWithHubert/CareerGuides";
import InterviewGuides from "../../components/learnWithHubert/InterviewGuides";
import NewestOnTheFeed from "../../components/learnWithHubert/NewestOnTheFeed";
import PickedForYou from "../../components/learnWithHubert/PickedForYou";
import "./LearnWithHubert.css";

const LearnWithHubert = () => {
    const [selectedTab, setSelectedTab] = useState("yourFeed");
    const { data: contentCollection, isLoading: loading } = useQuery({
        queryKey: ["contentCollection", { limit: 12, page: 1 }],
        queryFn: fetchContentCollection({
            tags: [],
            optionalTags: [],
            limit: 12,
            page: 1,
        }),
    });

    const tabs = [
        {
            textKey: "LearnWithHubert.TabSelector.MyFeed",
            value: "yourFeed",
        },
        {
            textKey: "LearnWithHubert.TabSelector.InterviewGuides",
            value: "interviewGuides",
        },
        {
            textKey: "LearnWithHubert.TabSelector.CareerGuides",
            value: "careerGuides",
        },
    ];

    const renderComponents = () => {
        if (selectedTab === "yourFeed" && contentCollection) {
            return (
                <>
                    <NewestOnTheFeed article={contentCollection.contents[0]} />
                    <PickedForYou articleCollection={contentCollection} loading={loading} />
                </>
            );
        }

        if (selectedTab === "interviewGuides") return <InterviewGuides />;
        if (selectedTab === "careerGuides") return <CareerGuides />;
        return "";
    };

    return (
        <>
            <Header type="LoggedIn" />
            <div className="learn-with-hubert-wrapper">
                <BannerSection />
                <div className="custom-tab-selector-wrapper">
                    <TabSelector
                        variant="pill"
                        tabs={tabs}
                        selectedTab={selectedTab}
                        setSelectedTab={setSelectedTab}
                        hugContent
                    />
                </div>
                {renderComponents()}
            </div>
            <Footer />
        </>
    );
};

export default LearnWithHubert;
